module.exports = __webpack_public_path__ + "housingStatic/img/park_img.d8304ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/park_img.png
// module id = QmUd
// module chunks = 2